// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2skT4","search":"Settings_search__ZXl8w","filter":"Settings_filter__2Kw9x"};